// MEM: keep all shipping bars in sync with cart state.
(function () {
  if (window.__memShipbarInit) return;
  window.__memShipbarInit = true;

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return 'LE ' + amount + ' EGP';
  }

  function update() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-mem-shipbar]').forEach(function (bar) {
          var threshold = parseInt(bar.getAttribute('data-mem-threshold'), 10) || 200000;
          var remaining = threshold - cart.total_price;
          var progress = Math.min(100, (cart.total_price / threshold) * 100);
          var fill = bar.querySelector('[data-mem-shipbar-fill]');
          var msg = bar.querySelector('[data-mem-shipbar-msg]');
          if (fill) fill.style.width = progress + '%';
          if (msg) {
            if (remaining > 0) {
              msg.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> for <strong>free shipping in Cairo</strong>';
            } else {
              msg.innerHTML = '<span class="mem-shipbar__unlocked">✓ You qualify for free shipping in Cairo</span>';
            }
          }
        });
      });
  }

  // Update on relevant events
  document.addEventListener('click', function (e) {
    if (e.target.closest('button[name="add"], .product-form__submit, [data-mem-msticky-btn]')) {
      setTimeout(update, 600);
      setTimeout(update, 1500);
    }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('input[name="updates[]"], .quantity__input')) setTimeout(update, 400);
  });
  // Listen for Dawn's cart events
  ['cart:update', 'cart:add', 'cart:refresh'].forEach(function (evt) {
    document.addEventListener(evt, function () { setTimeout(update, 200); });
  });
  // Initial sync
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
})();
